import connectedComponent from './StylePopup';

export default connectedComponent;